import { useState } from 'react';
import { patchAPI } from '../services/api.service';
import { toast } from 'react-toastify';

export const useArchiveGroup = () => {
  const [loading, setLoading] = useState(false);

  const handleArchiveGroup = async (groupId: string, isArchived: boolean) => {
    setLoading(true);
    try {
      const response = await patchAPI(`/groups/archive/${groupId}`, { isArchived });
      if (response.status === 200) {
        toast.success(`Group ${isArchived ? 'archived' : 'unarchived'} successfully!`);
      } else {
        toast.error(`Failed to ${isArchived ? 'archive' : 'unarchive'} group.`);
      }
    } catch (error) {
      toast.error('An error occurred while updating the group status.');
    } finally {
      setLoading(false);
    }
  };

  return { handleArchiveGroup, loading };
};
